<template>
  <div>
    <div
      class="luckyModel"
      v-if="isShowLuckying || isShowLuckyList || isShowWinningList"
    >
      <div class="lucky-close">
        <span class="icontemp stemp-close" @click="close()"></span>
      </div>
      <div class="lucky-winner-list">
        <div v-if="isShowLuckying || isShowLuckyList">
          <div class="lucky-award-name">{{ luckyName }}</div>
          <div class="lucky-wenzi">
            <img
              :src="
                luckyImageUrl || require('../../assets/images/luckyDrow.jpg')
              "
              class="lucky-im"
            />
          </div>
          <div class="lucky-title">{{ awardName }}</div>
          <div class="lucky-box">
            <div class="lucky-award"></div>
            <div class="lucky-content">
              <div class="lucky-ctent">
                <!--抽奖中开始-->
                <div class="lucky-ing" v-if="isShowLuckying">
                  抽奖进行中
                </div>
                <div class="lucky-ing-roll" v-if="isShowLuckying">
                  <img src="../../assets/images/roll.gif" alt="" />
                </div>
                <!--抽奖中开始-->

                <!--抽奖结果开始-->
                <div class="lucky-ing" v-if="isShowLuckyList">
                  {{ isWinner ? "恭喜您中奖了" : "很遗憾您没中奖" }}
                </div>
                <div class="winner-list" v-if="isShowLuckyList">
                  <div
                    class="winner-item"
                    v-for="(p, i) in winnerList"
                    :key="i"
                  >
                    {{ p.showName }}
                  </div>
                </div>
              </div>
            </div>
            <p class="lucky-remind">
              {{ message }}
            </p>
          </div>
        </div>

        <div class="lucky-box" v-if="isShowWinningList">
          <div class="lucky-content">
            <div class="lucky-award"></div>
            <div class="lucky-ctent w-list">
              <!--抽奖中开始-->
              <div class="item" v-for="(l, i) in luckyList" :key="i">
                <div class="name">{{ l.name }}</div>
                <div class="img">
                  <img
                    :src="
                      l.image || require('../../assets/images/luckyDrow.jpg')
                    "
                    alt=""
                  />
                </div>
                <div class="award">{{ l.awardName }}</div>
                <div class="list">
                  <div v-for="(w, i) in l.members" :key="i">
                    {{ w.showName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lottery-bg" v-if="isShowResult">
      <div class="draw-warp-zijie wap"  >
        <div class="close" @click="isShowResult = false">
          <img src="../../assets/images/lottery-close1.png" alt="">
        </div>
        <div v-show="isWinner" class="draw-in-box">
          <img src="../../assets/images/lottery-in.png" alt="">
        </div>
        <div v-show="isWinner" class="draw-tips">
          恭喜您已中奖
        </div>
        <div v-show="isWinner" class="draw-form">
          <div class="item">
            <span class="lable">姓&nbsp;&nbsp;&nbsp;名</span>
            <input v-model="drawName" :disabled="isAction" type="text">
          </div>
          <div class="item">
            <span class="lable">电&nbsp;&nbsp;&nbsp;话</span>
            <input v-model="drawMobile" type="text" :disabled="isAction">
          </div>
          <div class="item">
            <span class="lable">邮寄地址</span>
            <input v-model="drawAddress" type="text" :disabled="isAction">
          </div>
        </div>
        <div v-show="isWinner" :class="isSubmitting || isAction ? 'disable':''"  class="draw-button-box" @click="actionDrawCustomForm">
          <img src="../../assets/images/form-button.png" alt="">
          <span>提 交</span>
        </div>
        <div v-show="!isWinner" class="draw-out-box">
          <img src="../../assets/images/lottery-out.png" alt="">
        </div>
        <div v-show="!isWinner" class="draw-tips">
          谢谢参与
        </div>
        <div v-show="!isWinner" class="draw-sub-tips">
          很遗憾，您没有中奖
        </div>
        <div v-show="!isWinner" class="draw-winners-list">
          <div class="winner-list-title">
            中奖名单
          </div>
          <div class="winner-content-lists">
            <div class="winner-list-item" v-for="(item,index) in winnerList" :key="index">
              {{item.mobile}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="draw-warp-zijie-box wap"  v-if="isDrawnPrize">
      <div class="draw-warp-zijie-box-text ">
        本轮抽奖参与成功，即将开奖敬请关注!
      </div>
    </div>
  </div>
</template>

<script>
import {
  buildLotteryData,
  buildTableMethod,
  mounted
} from "../../common/lottery";
export default {
  name: "Lottery",
  data() {
    return buildLotteryData({});
  },
  created() {},
  methods: buildTableMethod({}),
  mounted() {
    return mounted(this);
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .lottery-bg{
    position: fixed;
    width: 100%;
    height: 100%;
    top:0;
    left: 0;
    z-index: 13;
    background-color: rgba(0,0,0,.6);
  }
</style>
